import axios from "axios";

const BASE_URL = import.meta.env.VITE_SWING_API_ENDPOINT;
const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true, // Important: This allows cookies to be sent with requests
});

let onSessionExpired: (() => void) | null = null;

export function setSessionExpiredHandler(handler: (() => void) | null) {
  onSessionExpired = handler;
}

// Request interceptor: Add JWT token to headers and cache-busting
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Add cache-busting for GET requests
    if (config.method === 'get') {
      config.params = {
        ...config.params,
        _t: Date.now() // Timestamp to prevent caching
      };
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 Unauthorized errors that indicate session expiration
    if (
      error.response?.status === 401 &&
      (error.response?.data?.code === "INVALID_TOKEN" ||
        error.response?.data?.error === "SESSION_EXPIRED" ||
        error.response?.data?.error === "No token provided" ||
        error.response?.data?.error === "Invalid token")
    ) {
      console.warn("🔒 Session expired or invalid. Logging out...");
      if (onSessionExpired) onSessionExpired();
    }
    return Promise.reject(error);
  }
);

export default api;
